import React from 'react';
import Hero from './components/Hero';
import Pillars from './components/Pillars';
import Services from './components/Services';
import Equipment from './components/Equipment';
import About from './components/About';
//import Insurance from './components/Insurance';
import ContactFooter from '../../components/ContactFooter/ContactFooter';
import cellBackground from "../../assets/images/home/big-cell.png";
import './styles.scss';

class Home extends React.Component {
	render() {
		return (
		<React.Fragment>
			<main id="home" className="main home">
				<Hero></Hero>
				<Pillars></Pillars>
				<Services id="servicios"></Services>
				<Equipment id="equipamiento"></Equipment>
				<About id="nosotros"></About>
				{/* <Insurance></Insurance> */}
				<img src={cellBackground} alt="" className="main__background-image"/>
			</main>
			<ContactFooter id="contacto" />
		</React.Fragment>
		)
	}
};

export default Home;